import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success("Accesso effettuato");
      const role = data.user.role;
      const dest = role === "admin" ? "/admin" : role === "manager" ? "/manager" : "/app";
      navigate(location.state?.from?.pathname || dest);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Credenziali non valide");
    } finally { setLoading(false); }
  };

  const quickLogin = (mail) => { setEmail(mail); setPassword("Demo2025!"); };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <aside className="hidden lg:flex w-1/2 bg-[#071225] text-white p-12 flex-col justify-between cxo-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 cxo-grid-bg opacity-20" />
        <Logo variant="light" size="lg" linkTo="/" />
        <div className="relative max-w-md">
          <h2 className="font-display text-3xl font-bold leading-tight">La leadership giusta, quando serve.</h2>
          <p className="mt-3 text-white/70">Accedi alla tua area CXOORA per gestire richieste, shortlist, progetti, milestone e KPI.</p>
        </div>
        <div className="text-xs text-white/50">© CXOORA - Fractional Management Platform</div>
      </aside>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-6"><Logo /></div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold text-slate-900">Bentornato</h1>
          <p className="mt-2 text-sm text-slate-600">Accedi alla tua area riservata.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="nome@azienda.it" data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="pwd">Password</Label>
              <Input id="pwd" type="password" required value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" data-testid="login-password" />
            </div>
            <Button type="submit" className="w-full bg-[#2D6BFF] hover:bg-[#1F57F2] text-white h-11" disabled={loading} data-testid="login-submit">
              {loading ? <Loader2 size={16} className="mr-2 animate-spin" /> : null} Accedi
            </Button>
          </form>
          <div className="mt-6 cxo-card p-4 bg-slate-50">
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">Account demo (Demo2025!)</p>
            <div className="grid grid-cols-1 gap-2 text-xs">
              <button type="button" onClick={() => quickLogin("admin@cxoora.demo")} className="text-left p-2 hover:bg-slate-100 rounded" data-testid="demo-login-admin">
                <span className="font-semibold text-slate-900">Admin</span> · admin@cxoora.demo
              </button>
              <button type="button" onClick={() => quickLogin("azienda@cxoora.demo")} className="text-left p-2 hover:bg-slate-100 rounded" data-testid="demo-login-company">
                <span className="font-semibold text-slate-900">Azienda</span> · azienda@cxoora.demo
              </button>
              <button type="button" onClick={() => quickLogin("manager@cxoora.demo")} className="text-left p-2 hover:bg-slate-100 rounded" data-testid="demo-login-manager">
                <span className="font-semibold text-slate-900">Manager</span> · manager@cxoora.demo
              </button>
            </div>
          </div>
          <p className="mt-6 text-sm text-slate-600 text-center">
            Non hai un account? <Link to="/register" className="font-semibold text-[#2D6BFF] hover:text-[#1F57F2]">Registrati</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
